export default (string) => {
  let messages = {
    "claims.firstBillTxtContent": "Before you Upload:",
    "balance.beforeFirst":
      "Only upload one statement per Provider and per date of service.",
    "balance.beforeSecond":
      "If you have multiple bills for a date of service that do not match your EOB, you will upload them separately.",
    "noUploads.pleaseNote": "Please Note:",
    "noUploads.uploadEOB":
      "Ensure you upload your EOB only for this DOS and this provider.",
    "nouploads.uploadQualityImage": "Upload one quality image at a time.",
    "balance.beforeThird":
      "Make sure to take a clear picture of all pages that are relative to this Provider and DOS.",
    "newUpload.pleaseNote": "Please Note: Patient Responsibility is Critical.",
    "newUpload.responsibility":
      "You are only responsible for the Patient Responsibility shown on your Plan’s Explanation of Benefits such as your deductible and/or coinsurance.",
    "newUpload.ensureUpload":
      "Ensure you upload receipts only for this DOS and this Provider.",
    "newUpload.patientResponsibility": "Patient Responsibility is Critical",
    "newUpload.PatientReceipt": "Patient Responsibility Receipt",
    "newUpload.paidYourPatient":
      "Have you paid your Patient Responsibility as stated on your Explanation of Benefits (EOB) ?",
    "newUpload.uploadReceipt": "Upload Patient Responsibility Receipt",
    "findProviderPage.contractGroupStatus":"Scheduling service with other providers may result in higher costs",
  };

  let vals = Object.values(messages);
  let index = vals.indexOf(string);
  return index > -1 ? Object.keys(messages)[index] : false;
};
